module.exports = __webpack_public_path__ + "winner-badge-team-2.01d911040146a2663d40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/winner-badge-team-2.svg
// module id = ./src/assets/svgs/winner-badge-team-2.svg
// module chunks = main